import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {ProductContent} from '../model/Entities/ProductContent';

@Injectable()
export class ProductContentService extends ApiService<ProductContent> {

    protected apiUrl = 'api/product-contents';  // URL to web api

    protected getObjectType(): any {
        return ProductContent;
    }
}



// WEBPACK FOOTER //
// /app/src/services/product-content.service.ts